export default __webpack_public_path__ + "static/media/nft3.4cac913d.png";